import { useAllWorklistContext } from 'views/pages/Worklist/AllWorklist/contexts/AllWorklistContext.ts';
import { useTaskListQuery } from 'common/cache';
import { ITaskTableEntry } from 'views/pages/Worklist/common/TaskTable/hooks';
import { TASK_PRIORITY } from 'common/types';

export const useIncomplete = () => {
  const {
    filters,
    handleFilterChange,
    handleOpenTaskDetails,
    selectedTaskId,
    handleFullResetIncompleteFilters,
    isFiltersCardOpen,
    handleCloseFiltersCard,
    handleToggleFiltersCard,
  } = useAllWorklistContext();

  const {
    data = {
      count: 0,
      tasks: [],
    },
    isFetching,
    isRefetching,
  } = useTaskListQuery(filters);

  const entries: ITaskTableEntry[] = data.tasks.map(task => ({
    ...task,
    priority: task.priority as TASK_PRIORITY,
  }));

  return {
    isFiltersCardOpen,
    handleCloseFiltersCard,
    handleToggleFiltersCard,
    entries,
    isLoading: isFetching || isRefetching,
    filters,
    handleFilterChange,
    totalCount: data.count,
    handleOpenTaskDetails,
    selectedTaskId,
    isInitialFilters: false,
    handleFullResetIncompleteFilters,
  };
};
